<template>
  <div class="global-container container-fluid">
    <div class="row">
      <div class="col-lg-6 right-reg">
        <div class="card login-form">
          <div class="card-body">
            <div id="logo_home" class="logologin">
              <h1>
                <img
                  src="../../../public/img/logo-pardis.png"
                  alt="City tours"
                  data-retina="true"
                  @click.prevent="gotoHome"
                  style="cursor: pointer"
                />
              </h1>
            </div>
            <div class="login-top-title">
              <h3>{{ $t("Login") }}</h3>
            </div>

            <div class="sign-in-wrapper">
              <div class="group_mdi">
                <i class="icon_mail_alt"></i>
                <input
                 v-on:keyup.enter="checkProfileUpdated"
                type="text" required v-model="data.username" />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label> {{ $t("UserName") }}</label>
              </div>
              <div class="group_mdi">
                <i class="icon_lock_alt"></i>
                <input
                  v-on:keyup.enter="checkProfileUpdated"
                  required
                  type="password"
                  v-model="data.password"
                />
                <span class="highlight"></span>
                <span class="bar"></span>
                <label>  {{ $t("Password") }}</label>
              </div>
              <!-- <div class="form-group inputContainer">
            <label>رمزعبور</label>
            <input
              class="form-control"
              type="password"
              v-model="data.password"
            />
            <i class="icon_lock_alt"></i>
          </div> -->
              <div class="forgot-password">
                <router-link to="/forgetpassword">
                  {{ $t("ForgetPassword") }}
                  </router-link>
              </div>
              <div class="login-btn-sec">
                <div class="dashed-line"></div>
                <button
                  v-if="!isLoading"
                  type="submit"
                  :value="$t('UserEntry')"
                  @click.prevent="checkProfileUpdated"
                  class="btn_login">
                   {{ $t("UserEntry") }}
                  
                </button>

                <button
                  v-if="isLoading"
                  type="submit"
                  :value="$t('UserEntry')"
                  class="btn_login"
                >
                  {{ $t("UserEntry") }}
                  <loadingBar type="ring" class="loading-btn"></loadingBar>
                </button>
              </div>

              <div class="gotosignup">
                  {{ $t("NotSignup") }}
                <router-link to="/register">  {{ $t("Signup") }} </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6 left-reg"></div>
    </div>
    <PdkConfirmDialog
      v-if="showModal"
      :buttonObject="modalButtonProps"
      @btnAction="resendEmail"
      @btnClose="btnClose"
    >
      <div style="text-align: center" slot="body">
        <h4 style="margin-top: 10px">
          {{ $t("SignupNotCompleted") }} 
        </h4>
      </div>
    </PdkConfirmDialog>

    <button type="submit" class="home-btn" @click.prevent="gotoHome">
      <i class="icon-home-1"></i>
      {{ $t("MainPage") }} 
    </button>
  </div>
</template>


<script>
import pdkCheckBox from "../../components/PdkCheckBox";
import store from "@/views/profile/store/index";
import loadingBar from "@/components/loading/pdkLoadingBar";
import PdkConfirmDialog from "./PdkConfirmDialog";
import $ from "jquery";
var qs = require("qs");

export default {
  name: "PdkLogin",
  store: store,
  components: {
    pdkCheckBox,
    loadingBar,
    PdkConfirmDialog,
  },

  data() {
    return {
      accessToken: "",
      refreshToken: "",
      popup: {},
      data: {
        username: "",
        password: "",
      },
      id: "",
      isLoading: false,
      showModal: false,
      modalButtonProps: {
        title: "ارسال مجدد لینک فعال سازی",
      },
    };
  },
  created() {
    localStorage.setItem("Version", process.env.VERSION);
    const userName = this.$route.params.userName;

    if (userName != undefined) this.data.username = userName;
  },
  methods: {
    async login() {
      this.isLoading = true;

      try {
        const res = await this.$store.dispatch("login", this.data);
        if (res !== undefined) {
          if (res.data.data.errorCode === 12) {
            // alert("ثبت نام کامل نشده است لطفا ایمیل خود را بررسی نمائید");
            this.showModal = true;

            return;
          }
          this.getUserId();
          this.$store.dispatch("getAllSourceConfirmed", this.id).then((res) => {
            this.sources = res;

            if (this.sources != null) {
              this.$store.dispatch(
                "getDepositInCrs",
                localStorage.getItem("SourceIdInReport")
              );
            }

            if (this.$route.name != "main home") {
              // this.$router.push("/");
              if (localStorage.getItem("UserId") !== null) {
                this.getUserMenus();
              }
            }
          });
        } else {
          // alert("نام کاربری یا کلمه عبور اشتباه است");
          this.$toast.error("نام کاربری یا کلمه عبور اشتباه است", {
            position: "top-center",
            timeout: 4500,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 1.59,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            icon: true,
            rtl: true,
          });
        }
      } catch (err) {
        // alert("نام کاربری یا کلمه عبور اشتباه است");
        this.$toast.error("نام کاربری یا کلمه عبور اشتباه است", {
          position: "top-center",
          timeout: 4500,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 1.59,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          icon: true,
          rtl: true,
        });
        this.isLoading = false;
      } finally {
        this.isLoading = false;
      }
    },
    async checkProfileUpdated() {
      this.isLoading = true;

      const params = {
        username: this.data.username,
        password: this.data.password,
      };
      const res = await this.$store.dispatch("checkProfileUpdatedPass", params);

      if (res.responseData.errorCode == 0) {
        const changePassParams = {
          userId: this.data.username,
          oldPassword: "Pa$$word123",
          password: this.data.password,
          confirmPassword: this.data.password,
        };

        const resPass = await this.$store.dispatch(
          "clientChangeUserPassword",
          changePassParams
        );
        if (resPass.status === 200) {
          this.login();
        }
      } else if (res.responseData.errorCode === 18) {
        this.login();
      } else if (res.responseData.errorCode === 22) {
        alert("حساب کاربری غیر فعال می باشد");
        this.isLoading = false;
      } else if (res.responseData.errorCode === 20) {
        if (res.message === 2) {
          alert("حساب کاربری غیر فعال می باشد");
        } else {
          this.login();
        }
      } else {
        // alert("نام کاربری یا کلمه عبور اشتباه است");
        this.$toast.error("نام کاربری یا کلمه عبور اشتباه است", {
          position: "top-center",
          timeout: 4500,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 1.59,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          icon: true,
          rtl: true,
        });
        this.isLoading = false;
      }
    },
    async getUserId() {
      this.id = localStorage.getItem("UserId");
    },
    gotoHome() {
      if (this.$route.name != "main home") this.$router.push("/");
    },
    async resendEmail() {
      const data = {
        policy: 1,
        userId: this.data.username,
        // redirectUri: uri.confirmPasswordUri,
      };
      const res = await this.$store.dispatch("resendConfirmationEmail", data);

      this.showModal = false;
    },

    btnClose() {
      this.showModal = false;
    },
    async getUserMenus() {
      this.isLoading = true;
      const data = {
        resourceId: 1,
        userId: localStorage.getItem("UserId"),
      };
      const res = await this.$store.dispatch(
        "getUserMenus",
        qs.stringify(data)
      );
      const menuList = await this.createTree(res);
      // this.$store.dispatch("fillMenuList", menuList);

      localStorage.setItem("menuList", JSON.stringify(menuList));
      this.$store.dispatch("changeMenuItemStatus", true);

      if (menuList.length)
        if (menuList.filter((p) => p.name === "topline")[0] != undefined) {
          this.topline = menuList.filter(
            (p) => p.name === "topline"
          )[0].children;
          this.topline.sort(function (a, b) {
            return a.sortId - b.sortId;
          });
        }
      this.getCustomerDataByBusiness();
      this.isLoading = false;
    },
    async createTree(arr) {
      var tree = [],
        mappedArr = {},
        arrElem,
        mappedElem;

      for (var i = 0, len = arr.length; i < len; i++) {
        arrElem = arr[i];
        mappedArr[arrElem.id] = arrElem;
        if (arrElem.name !== "dashboard") {
          mappedArr[arrElem.id]["children"] = [];
        }
      }

      for (var id in mappedArr) {
        if (mappedArr.hasOwnProperty(id)) {
          mappedElem = mappedArr[id];
          if (mappedElem.parentId) {
            mappedArr[mappedElem["parentId"]]["children"].push(mappedElem);
          } else {
            tree.push(mappedElem);
          }
        }
      }
      return tree;
    },
    async getCustomerDataByBusiness() {
      const res = await this.$store.dispatch(
        "getProfileByProfileId",
        localStorage.getItem("UserId")
      );
      if (res.data !== "") {
        if (res.data.profileId != "00000000-0000-0000-0000-000000000000") {
          localStorage.setItem("IntroductionModalCount", 1);
          this.$router.push("/profile/dashboard");
        }
      } else {
        this.$router.push("/");
      }
    },
  },
};
</script>

<style>
html,
body {
  height: 100%;
  background-color: #f5f7f9;
}

.global-container {
  height: 100vh !important;
  background-color: #f5f7f9;
  padding-top: 5%;
  background-image: url("../../../public/img/a89dausd90as90duajsdasd09 copy_c.jpg");
  background-size: cover;
}

.login-top-title {
  text-align: center;
  margin: 30px 20px;
}

.login-top-title h3 {
  font-size: 16px;
  color: #2561a4;
}

.card-title {
  font-weight: 300;
}

.btn {
  font-size: 14px;
  margin-top: 20px;
}

.login-form {
  width: 64%;
  margin-right: 17%;
  border-radius: 25px;
  box-shadow: -1.2px -0.7px 2.2px rgb(0 0 0 / 1%),
    -1.4px -0.8px 5.3px rgb(0 0 0 / 2%), 0.1px 0px 10px rgb(0 0 0 / 2%),
    4.3px 2.5px 17.9px rgb(0 0 0 / 2%), 15.2px 8.8px 33.4px rgb(0 0 0 / 3%),
    50px 29px 80px rgb(0 0 0 / 4%);
}

.logologin {
  margin-right: 0px;
  text-align: center;
}

.logologin img {
  width: 360px;
}

.card-body {
  padding: 30px 15px 30px 15px;
  line-height: 1.6 !important;
  border-top: 0px solid;
}

.home-btn {
  border: 1px solid #fff;
  position: fixed;
  left: 70px;
  top: 70px;
  width: 120px;
  height: 120px;
  border-radius: 100%;
  box-shadow: -1.2px -0.7px 2.2px rgb(0 0 0 / 1%),
    -1.4px -0.8px 5.3px rgb(0 0 0 / 2%), 0.1px 0px 10px rgb(0 0 0 / 2%),
    4.3px 2.5px 17.9px rgb(0 0 0 / 2%), 15.2px 8.8px 33.4px rgb(0 0 0 / 3%),
    50px 29px 80px rgb(0 0 0 / 4%);
  background: #0e6d7c;
  color: #fff;
  font-size: 16px;
  line-height: 1.5;
}

.home-btn i {
  display: block;
  font-size: 30px;
  margin-top: -5px;
}

.inputContainer i {
  position: absolute;
  margin: -34px 10px;
  text-align: left !important;
  float: left;
  font-size: 20px;
  color: #ccc;
}

.inputContainer {
  width: 100%;
  margin-bottom: 10px;
}

.group_mdi .bar {
  position: relative;
  display: block;
}

.loading-btn {
  padding-right: 50px !important;
}

.group_mdi label {
  right: 60px;
}

.small-dialog-header {
  font-size: 18px;
  width: calc(100%);
  right: 0px;
  top: 0;
  -webkit-border-radius: 4px 4px 0 0;
  -moz-border-radius: 4px 4px 0 0;
  border-radius: 4px 4px 0 0;
  display: inline-block;
  background-color: #fff;
  padding: 15px 20px;
  margin-bottom: 30px;
}

#logo_home h1 a,
header#colored #logo_home h1 a,
header#plain #logo_home h1 a,
header.sticky #logo_home h1 a {
  width: 160px;
  height: 34px;
  display: block;
  background-image: url(../../../public/img/pdk_logo.png);
  background-repeat: no-repeat;
  background-position: left top;
  background-size: 160px 34px;
  text-indent: -9999px;
  text-align: center;
  margin: 20px;
}

@media (max-width: 767.98px) {
  .global-container {
    background-image: url("../../../public/img/e4g9w88g4ew48g8we_dariushgroup.jpg");
    background-size: cover;
    padding-top: 15%;
  }

  .card {
    background-color: #ffffffe8;
  }

  .login-form {
    width: 96%;
    margin-right: 2%;
  }

  .logologin img {
    width: 100%;
  }

  .login-top-title {
    display: none;
  }

  .forgot-password {
    margin-top: 20px;
  }

  .home-btn {
    display: none !important;
  }
}
</style>